module.exports = __webpack_public_path__ + "img/download-arquivo.bffe37cf.svg";